import "../scss/identification.scss";
import {plugin_registry, PluginBase} from "nk-plugin-registry";


@plugin_registry.register("IdentificationSearch")
class IdentificationSearch extends PluginBase {
    constructor($node) {
        super($node);
        this._$node = $node;

        this.$search_input = $node.querySelector('[data-js-select="search-input"]');
        this.$items = $node.querySelectorAll('[data-js-select="item"]');
        this.$nothing_found_message = $node.querySelector('[data-js-select="nothing-found"]');
        this.$show_input = $node.querySelector('[data-js-select="show-input"]');
    }

    loaded($node) {
        super.loaded($node);
        this._install_event_listeners();
    }

    _install_event_listeners = () => {
        this.$search_input.addEventListener('input', (e) => this._filter_list(e))
    }

    _filter_list = (e) => {
        let inputValue = e.target.value;

        let nothing_found = true;
        if (inputValue.length) {
            inputValue = inputValue.toLowerCase()
            for (const item of this.$items) {
                const itemText = item.textContent.toLowerCase()
                if (itemText.includes(inputValue)) {
                    nothing_found = false;
                    item.classList.remove("hidden")
                } else {
                    item.classList.add("hidden")
                }
            }
        } else {
            for (const item of this.$items) {
                item.classList.remove("hidden")
            }
        }

        if (nothing_found && inputValue.length) {
            this.$nothing_found_message.classList.remove("hidden")
            this.$show_input.innerHTML = `"${inputValue}"`;
        } else {
            this.$nothing_found_message.classList.add("hidden")
            this.$show_input.innerHTML = "";
        }
    }
}


@plugin_registry.register("CompareSpecies")
class CompareSpecies extends PluginBase {
    constructor($node) {
        super($node);
        this._$node = $node;

        this.$attribute_buttons_left = $node.querySelectorAll('[data-js-select="attribute-button-left"]')
        this.$attribute_buttons_right = $node.querySelectorAll('[data-js-select="attribute-button-right"]')

        this.$image_left = $node.querySelector('[data-js-select="image-left"]')
        this.$image_right = $node.querySelector('[data-js-select="image-right"]')
    }

    loaded($node) {
        super.loaded($node);
        this._install_event_listeners();
    }

    _install_event_listeners = () => {

        this.$attribute_buttons_left.forEach((button) =>
            button.addEventListener('click', (e) => this._add_image(e, "left"))
        )
        this.$attribute_buttons_right.forEach((button) =>
            button.addEventListener('click', (e) => this._add_image(e, "right"))
        )
    }

    _add_image = (e, side) => {
        const img_url = e.target.getAttribute("data-js")
        if (side === "left") {
            this.$image_left.setAttribute("src", img_url)
            this.$image_left.classList.remove("hidden")
            this.$attribute_buttons_left.forEach((button) =>
                button.classList.remove("active")
            )
            e.target.classList.add("active")
        } else {
            this.$image_right.setAttribute("src", img_url)
            this.$image_right.classList.remove("hidden")
            this.$attribute_buttons_right.forEach((button) =>
                button.classList.remove("active")
            )
            e.target.classList.add("active")
        }

    }
}
